module.exports = __webpack_public_path__ + "static/media/29FUNOV14.4caf884d.jpg";